export const employerApplicationsKey = 'employerApplications';
export const applicationHistoryKey = 'applicationHistoryKey';
export const enterpriseApplicationsKey = 'enterpriseApplications';
export const compnayListKey = 'companyList';
export const companiesPlansList = 'companiesPlansList';
export const enterpriseCodeKey = 'enterpriseCode';
export const enterpriseTagsKey = 'enterpriseTags';
export const interviewCountsKey = 'interviewCountsKey';
export const employerTagsKey = 'employerTags';
export const applicationsCountsKey = 'applicationsCounts';
export const applicantApplicationsKey = 'applicantApplications';
export const applicationsKey = 'applicationsKey';
export const errorMessage = 'Sorry, something went wrong';
export const errorAIMessage =
  'The AI Assistant is unavailable at the moment. Please retry in a few minutes.';
